var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"dropzone-content"},[_c('div',{staticClass:"dropzone-title"},[_c('AddPhotoIcon',{staticClass:"mt-5 mb-2"}),_vm._m(0),_c('p',{staticClass:"small"},[_vm._v("PNG, JPG, GIF up to 10MB")])],1)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('p',[_c('span',{staticClass:"primary"},[_vm._v("Upload a file")]),_vm._v(" or drag and drop")])
}]

export { render, staticRenderFns }